import {AdvancedMarker, APIProvider, ControlPosition, Map as GoogleMaps, Pin, useAdvancedMarkerRef} from "@vis.gl/react-google-maps";
import React, {useContext, useEffect} from "react";
import {GeoreferencedSearchContext} from "../../context/georeferenced-search-context.jsx";
import RoutePolyline from "./overlays/route-polyline.jsx";
import {FitBounds} from "./viewport/fit-bounds.jsx";
import {MarkerCluster} from "./markers/marker-cluster.jsx";
import CenterOnSelection from "./viewport/center-on-selection.jsx";
import SelectableMarker from "./markers/selectable-marker.jsx";
const GeoreferencedSearchMap = ({corporation, position, markersData, polylines}) => {
    const {options, currentPassage, setSelection, selection, gridApi, colorRegistry, mapZoomController, centerOnSelectionRef} = useContext(GeoreferencedSearchContext);
    const onMarkerClick = (lat, lng) => {
        centerOnSelectionRef.current = true;
        const passages = Array.from(markersData.values())
            .filter(item => item.lat === lat && item.lng === lng)
            .map(el => el.data);

        if (!options.groupByPlate) {
            setSelection({
                type: passages.length > 1 ? 'multiple' : 'single',
                data: passages.length > 1 ? passages : passages[0],
                passageId: null,
            });
            return;
        }

        const passagesById = new Set(passages.map(p => p.id));
        const passagesByPlate = new Map(
            passages.map(p => [p.plate.rawValue, p])
        );

        const matchedGroups = [];
        const passagesIds = new Map();

        gridApi.current.forEachNode(rowNode => {
            if (!rowNode.data?.passages) return;

            const hasMatch = rowNode.data.passages.some(p =>
                passagesById.has(p.id)
            );

            if (hasMatch) {
                matchedGroups.push(rowNode.data);
                passagesIds.set(
                    rowNode.id,
                    passagesByPlate.get(rowNode.id)
                );
            }
        });

        setSelection({
            type: matchedGroups.length > 1 ? 'multiple' : 'single',
            data: matchedGroups.length > 1 ? matchedGroups : matchedGroups[0],
            passageId: matchedGroups.length > 1 ? passagesIds : null,
        });
    };

    return(
        <APIProvider apiKey={corporation?.maps_api_key ?? ""} language={"pt-BR"} libraries={["places"]}>
            <GoogleMaps
                mapId="a7e2dbd01b9a18afb82d00c6"
                defaultZoom={14}
                fullscreenControlOptions={{position: ControlPosition.BOTTOM_RIGHT}}
                reuseMaps={true}
                defaultCenter={position}
                streetViewControl={false}
                mapTypeControl={true}
                scrollwheel={true}
                gestureHandling={'greedy'}
                style={{ height: "95%", width: "100%" }}
                mapTypeControlOptions={{position: ControlPosition.TOP_RIGHT}}
            >
                <FitBounds markers={Array.from(markersData.values())} mapZoomController={mapZoomController}/>
                {options.groupByMarker ? (
                    <MarkerCluster
                        markersData={markersData}
                        onMarkerClick={onMarkerClick}
                        selectedMarkerId={
                            options.groupByPlate
                                ? selection.data?.passages?.[currentPassage]?.id
                                : selection.data?.id
                        }
                    />
                ) : (
                    Array.from(markersData.entries()).map(([key, marker]) => {
                        const selectedId = options.groupByPlate
                            ? selection.data?.passages?.[currentPassage]?.id
                            : selection.data?.id;

                        return (
                            <SelectableMarker
                                key={key}
                                marker={marker}
                                isSelected={marker.id === selectedId}
                                onClick={() => onMarkerClick(marker.lat, marker.lng)}
                            />
                        );
                    })

                    )}
                <CenterOnSelection
                    passage={selection}
                    centerOnSelectionRef={centerOnSelectionRef}
                    options={options}
                    currentPassage={currentPassage}
                />
                {polylines.map(polyline => (
                    <RoutePolyline
                        key={polyline.id}
                        path={polyline.path}
                        options={polyline.options}
                    />
                ))}

            </GoogleMaps>
        </APIProvider>
    )
}

export default GeoreferencedSearchMap;